import { OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import React, { useEffect, useState } from 'react'

import * as THREE from "three";
import { v } from '../../env/env_variable';
import PlanetDetails from './body_details/PlanetDetails';
import MoonDetails from './body_details/MoonDetails';
import EllipticalOrbit from './EllipticalOrbit';
import Moon from './Moon';
import Ring from './Ring';

function PlanetView(props) {
    
    const planetIndividualViewData = props.planetData

    // All States:
    const [planetTexture, setPlanetTexture] = useState()

    useEffect(() => {
        const textureLoader = new THREE.TextureLoader();
        const texture = textureLoader.load(require(`${planetIndividualViewData.textures.base}`));
        setPlanetTexture(texture);
    }, [])
    


    return (
        <div style={{width: '100%', height: '100%'}}>
        
        <PlanetDetails planet={planetIndividualViewData} />
        <MoonDetails planet={planetIndividualViewData} />
        

        <div style={{width: '100%', height: '100%'}}>
            <Canvas
              camera={{
                fov: 750, // Field of view
                aspect: window.innerWidth / window.innerHeight, // Aspect ratio
                near: 0.01, // Near clipping plane
                far: 10000000, // Far clipping plane
                // position: cameraPosition, // Adjust the camera position
              }}

              
            >
              <OrbitControls />
              <ambientLight intensity={0.8} />
              {/* <pointLight position={[0, 0, 0]} intensity={1} /> */}
            
              {
                planetTexture &&
                <group>
                   <mesh>
                    <sphereGeometry args={[planetIndividualViewData.diameter/2 * 100/v.scale, 100]} />
                    <meshStandardMaterial map={planetTexture}/>
                  </mesh>

                  <Ring planet={planetIndividualViewData} planetPosition={[planetIndividualViewData.rings.innerRadius * 100 / v.scale, planetIndividualViewData.rings.outerRadius * 100 / v.scale, 100]}/>

                  {/* {isSaturnWithRings && (
                    <mesh 
                    rotation={ringsRotation}>
                      <ringGeometry
                        args={[planetIndividualViewData.rings.innerRadius * 100 / v.scale, planetIndividualViewData.rings.outerRadius * 100 / v.scale, 100]}
                      />
                      <meshStandardMaterial map={ringsTexture} color={"white"} transparent={true} side={THREE.DoubleSide} />
                    </mesh>
                  )} */}

                  {props.planetData.satellites.map(moon => (
                    <group>
                      <EllipticalOrbit color="rgb(58, 58, 58)" name={moon.name} semimajorAxis={moon.distanceFromParent* 10} eccentricity={moon.eccentricity? moon.eccentricity:0} inclination={moon.orbitalInclination} />

                      <mesh>
                        <Moon position={[(moon.distanceFromParent/v.posX)*v.distanceScalingFactor, 0, 0]} radius={moon.diameter*v.sizeScalingFactor*20000} data={moon} 
                          // onSetCameraFocus={(position, diameter) => changeFocusOfCamera(position, diameter)}
                          // showPlanetName={hidePlanetName}
                          // onSetPlanetData = {(data) => {setPlanetDataFtn(data); setHidePlanetName(true)}}
                        ></Moon>
                      </mesh>
                    </group>
                  ))}
                </group>
               
              }

              
              

            </Canvas>
        </div>

        </div>
    )
}

export default PlanetView